import React from 'react';
import { Page, Document, Image, StyleSheet, View, Text, Font } from '@react-pdf/renderer';
import THSarabunIT from '../../../asset/fonts/THSarabunNew.ttf';

import {
    Table,
    TableHeader,
    TableCell,
    TableBody,
    DataTableCell,
  } from "@david.kucsai/react-pdf-table";
  
Font.register({ family: 'THSarabunIT', src: THSarabunIT });


const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: '#ffffff',
        fontFamily: 'THSarabunIT',
        padding: 10,
    },
    contentContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    title: {
        textAlign: 'center',
        fontSize: 25,
    },
});

const ProductListDocument = ({ data, d_label }) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.contentContainer}>
                    <Text style={styles.title}>คลังคงเหลือรายการโปรดักส์ สาขา: {d_label}</Text>
                </View>
                <View>
                    <Table data={data}>
                            <TableHeader>
                                <TableCell style={{ textAlign: 'center',backgroundColor:'grey' ,fontSize:'11' }}>
                                    รหัสโปรดักส์  
                                </TableCell>
                                <TableCell style={{ textAlign: 'center',backgroundColor:'grey' ,fontSize:'11' }}>
                                    ชื่อโปรดักส์ 
                                </TableCell>
                                <TableCell style={{ textAlign: 'center',backgroundColor:'grey',fontSize:'11' }}>
                                    สาขา 
                                </TableCell>
                                <TableCell style={{ textAlign: 'center',backgroundColor:'grey',fontSize:'11' }}>
                                    <Text>
                                    จำนวนโปรดักส์คงเหลือ 
                                    </Text>
                                </TableCell>
                            </TableHeader>
                            <TableBody>
                                <DataTableCell style={{ textAlign: 'center' }} getContent={(r) => r.id}/>
                                <DataTableCell style={{ textAlign: 'center' }} getContent={(r) => r.product_name}/>
                                <DataTableCell style={{ textAlign: 'center' }} getContent={(r) => r.department_name}/>
                                <DataTableCell style={{ textAlign: 'center' }} getContent={(r) => r.product_quantity}/>
                            </TableBody>
                        </Table>
            </View>
    </Page>
  </Document>
  );
          };

export default ProductListDocument;
